const messages = {
  'lang_it': 'ITA',
  'lang_en': 'ENG',
  'visit': "Visit the house",
  'more': "Read more",
  'contact': "Contact Us",
  'houses': "Links",
  'rooms': "Rooms Description",
  'book': "Book"
};

export default messages;



// WEBPACK FOOTER //
// ./src/locales/en.js